import routeReplaceSelf from '@/utils/routeReplaceSelf';

const storeTaskManage = {
    path: 'storeTaskManage',
    name: 'storeTaskManage',
    component: () => import('@/layout'),
    redirect: 'noRedirect',
    meta: {
        code: 'storeTask',
        icon: 'HSIconfont hs-icon-task',
        showRealm: ['NORMAL']
    },
    children: [
        {
            path: 'storeTaskCycle',
            name: 'storeTaskCycle',
            component: routeReplaceSelf(() => import('@/views/storeTaskCycle')),
            meta: { code: 'storeTask:strategyV2' },
            children: [
                {
                    path: 'storeTaskCycleEslDetail',
                    name: 'storeTaskCycleEslDetail',
                    hidden: true,
                    component: () => import('@/views/storeTaskCycleEslDetail'),
                    meta: {
                        code: 'storeTask_strategyV2_timerTaskHistory',
                        activeMenu: 'storeTaskCycle',
                    },
                },
            ]
        },
        {
            path: 'storeTaskRepush',
            name: 'storeTaskRepush',
            component: routeReplaceSelf(() => import('@/views/storeTaskRepush')),
            meta: { code: 'storeTask:repushTask' },
            children: [
                {
                    path: 'storeTaskRepushEslDetail',
                    name: 'storeTaskRepushEslDetail',
                    hidden: true,
                    component: () => import('@/views/storeTaskRepushEslDetail'),
                    meta: {
                        code: 'storeTask_repushTask_timerTaskHistory',
                        activeMenu: 'storeTaskRepush',
                    },
                },
            ]
        },
        {
            path: 'storeTaskScheduledPage',
            name: 'storeTaskScheduledPage',
            component: () => import('@/views/storeTaskScheduledPage'),
            meta: {
                code: 'storeTask:eslSwitchPageTask',
            }
        }
    ]
};

export default storeTaskManage;
